import { Navbar } from './Navbar/Navbar.jsx';
import './Welcome.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Sidenav } from '../SideNav/Sidenav.js';
import { ResponsiveContainer, Area, AreaChart, YAxis, XAxis } from 'recharts';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import { conn } from '../../Utilt/conn.js';
import { getTransactionCount, getTransactionValue, getTotalAccounts, getUserCount, amountprefix, nFormatter } from '../../APIs/Metrics/Metrics.js';
import { AiOutlineCalendar } from 'react-icons/ai';
import { Modal, Box } from '@mui/material';
import { Modalstyle } from '../Modals/UploadImage/UploadImageModalStyle';
import { updateDates } from '../../ReduxStore/Metric'
import { Fade } from 'react-awesome-reveal';
import {getConfig} from '../../Utilt/Config';
import Layout from '../../ReuseComponent/Layout/Layout.jsx';


export function Welcome() {

   
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const transactedval = useSelector((state) => state.metric.transactedValue)
    const total_accounts = useSelector((state) => state.metric.total_accounts)
    const total_transactions = useSelector((state) => state.metric.total_transactions)
    const total_female = useSelector((state) => state.metric.total_female_user)
    const total_male = useSelector((state) => state.metric.total_male_user)


    const fromdate = useSelector((state) => state.metric.starting)
    const todate = useSelector((state) => state.metric.ending)


    const token = window.localStorage.getItem("token");

    useEffect(() => 
        (token === "" || token === null) && navigate("/login")
    , [])

    const auth = JSON.parse(window.localStorage.getItem("auth"));

    const [userJoin, setUserJoin] = useState([]);
    const [chartTransVal, setChart] = useState([]);
    const [transCount, setTransCount] = useState([]);

    const [isloaded, loading] = useState(false);
    const [isloaded2, loading2] = useState(false);
    const [isloaded3, loading3] = useState(false);

    const [signOpen, setSignOpen] = useState(false);
    const opensign = () => setSignOpen(true)
    const closesign = () => setSignOpen(false);


    const [loadingUser, setLoadingUser] = useState(false);
    const [loadingTransVal, setLoadingTransVal] = useState(false);
    const [laodingTransCount, setLoadingTransCount] = useState(false);

    //Dates
    // const d = new Date(val);
    // d.setDate(d.getDate()-1);
    const [fromDate, setFromDate] = useState('');
    const [fromDateUTC, setFromDateUTC] = useState(fromdate);

    const [toDate, setToDate] = useState('');
    const [toDateUTC, setToDateUTC] = useState(todate);



    const ValidateDate = () => {

        dispatch(updateDates({ starting: fromDateUTC, ending: toDateUTC }));
        
        closesign();

        setLoadingUser(true);
        setLoadingTransVal(true);
        setLoadingTransCount(true);

        FetchUserJoin();
        FetchTransacCount();
        FetchChartTransVal();

    }

    //Dates

    const FetchTransacCount = async () => {
        await axios.post(conn + "/admin/metrics/transactions/count/timeline", {
            "fromDate": fromDateUTC,
            "toDate": toDateUTC
        }, getConfig()).then((value) => {
            setTransCount(value.data.data);
            loading2(true); console.log(value.data);
            setLoadingTransCount(false);
        }).catch((error) => {
            console.log(error);
            setLoadingTransCount(false);
            if (error.response.status === 401) navigate('/login')
        });
    }


    const FetchUserJoin = async () => {
        console.log(fromDateUTC)
        console.log(toDateUTC)
        await axios.post(conn + "/admin/metrics/users/joins/timeline", {
            "fromDate": fromDateUTC,
            "toDate": toDateUTC
        }, getConfig()).then((value) => {
            setUserJoin(value.data.data);
            loading(true);
            // console.log(value.data);
            setLoadingUser(false);
        }).catch((error) => {
            console.log(error);
            setLoadingUser(false);
            if (error.response.status === 401) navigate('/login')
        });
    }


    const FetchChartTransVal = async () => {
        await axios.post(conn + "/admin/metrics/transactions/sum/timeline", {
            "fromDate": fromDateUTC,
            "toDate": toDateUTC
        }, getConfig()).then((value) => {
            setChart(value.data.data);
            // console.log(value.data);
            loading3(true);
            setLoadingTransVal(false);
        }).catch((error) => {
            console.log(error);
            setLoadingTransVal(false);
            if (error.response.status === 401) navigate('/login')
        });
    }



    useEffect(() => {
        FetchUserJoin();
        FetchTransacCount();
        FetchChartTransVal();

        //Metric Value
        getTransactionCount(auth.id, dispatch)
        getTransactionValue(auth.id, dispatch)
        getTotalAccounts(auth.id, dispatch);
        getUserCount(auth.id, dispatch)
        //Metric Value
    }, [])

    const handleFromDate = (val) =>{
        setFromDate(val)

        const d = new Date(val);
        d.setDate(d.getDate()-1);
        setFromDateUTC(new Date(d.toISOString().split('T')[0]+'T23:59:59.000Z'))
    }

    const handleToDate = (val) =>{
        setToDate(val);
        setToDateUTC(val+'T23:59:59.000Z')
    }


    return (
        <div>
            <Layout showNav={false}>
                <Navbar img={auth.image} />
                <div className='body'>


                    <div className='three-column-grid'>

                        <div className='grid1'>

                            <div className='in'>
                                <p><span>Total Users</span></p>



                                <span className="grid-value-divide">
                                    <div className='values'><span>
                                        <Fade duration={1000}>{total_male}</Fade>
                                    </span><span style={{ fontSize: "10px", color: "#ccc" }}>Male</span></div>
                                    <div className='divider'></div>
                                    <div className='values'><Fade duration={2000}><span>
                                        <Fade duration={1000}>{total_female}</Fade>
                                    </span></Fade><span style={{ fontSize: "10px", color: "#ccc" }}>Female</span></div>
                                </span>


                            </div>

                        </div>

                        
                        <div className='grid2'>

                            <div className='in'>

                                <p><span>Total Accounts</span></p>

                                <Fade duration={2000}><span className="grid-value">{nFormatter(total_accounts,2)}</span></Fade>

                                <span className='detail'>These are the number of accounts</span>


                            </div>

                        </div>
                        <div className='grid3'>

                            <div className='in'>

                                <p><span>Total Transactions</span></p>

                                <Fade duration={2000}><span className="grid-value">{nFormatter(total_transactions,2)}</span></Fade>

                                <span className='detail'>These are the number of transactions</span>

                            </div>

                        </div>
                        <div className='grid4'>

                            <div className='in'>

                                <p><span>Transacted Value</span></p>

                                <Fade duration={2000}><span className="grid-value">N {nFormatter((transactedval/100),2)}</span></Fade>

                                <span className='detail'>The total amount that has been transacted</span>


                            </div>

                        </div>

                    </div>


                    <div className='user-sign-ups'>

                        <div className='in'>

                            <div class="filter-main-row">
                                <p style={{fontSize:"14px"}}>User sign ups</p>
                                <div className="filter-area" onClick={() => opensign()}>
                                    <span style={{ fontSize: "12px", marginRight: "10px" }}><AiOutlineCalendar /></span> <span>Filter by date</span>
                                </div>
                            </div>

                            {(isloaded && !loadingUser) ? <div className='chart' style={{ width: "100%", marginLeft: "-20px", fontWeight: "normal", padding: "30px 0px 0px 0px", fontSize: "10px", color: "red" }}>
                                {/* chh */}

                                <Fade duration={2000}><ResponsiveContainer width="100%" height={180}>

                                    <AreaChart data={userJoin}>

                                        <YAxis dataKey="value" allowDecimals={false} tickSize={22} tickLine={false} axisLine={false} padding={{ bottom: 0 }} />
                                        <Area type="monotone" dataKey="value" stroke="#C6CCC6" fill="#C6CCC6" />
                                        <XAxis tick={{ stroke: 'rgb(125, 123, 123)', strokeWidth: 0.3 }} interval={Math.floor(userJoin/2)} angle={0} dx={10} dy={8} dataKey="date" tickLine={false} padding={{ left: 0, right: 20 }} tickSize={13} allowDataOverflow={true} minTickGap={30} style={{ backgroundColor: "#fff", zIndex: "2" }} />

                                    </AreaChart>

                                </ResponsiveContainer></Fade>

                            </div> : <></>}

                        </div>

                    </div>



                    <div className='two-column-grid'>


                        <div className='grid5'>

                            <div className='in'>

                                <p>Number of transactions</p>

                                {(isloaded2 && !laodingTransCount) ? <div className='chart' style={{ width: "100%", marginLeft: "-20px", fontWeight: "normal", padding: "30px 0px 0px 0px", fontSize: "10px" }}>
                                    {/* chh */}

                                    <Fade duration={2000}><ResponsiveContainer width="100%" height={180}>

                                        <AreaChart data={transCount}>

                                            <YAxis allowDecimals={false} dataKey="value" tickSize={22} tickLine={false} axisLine={false} padding={{ bottom: 0 }} />
                                            <Area type="monotone" dataKey="value" stroke="#CCCCB4" fill="#CCCCB4" />
                                            <XAxis interval={Math.floor(transCount/9)} angle={0} tick={{ stroke: 'rgb(125, 123, 123)', strokeWidth: 0.3 }} dx={10} dy={8} dataKey="date" tickLine={false} padding={{ left: 0, right: 20 }} tickSize={10} allowDataOverflow={true} minTickGap={30} style={{ backgroundColor: "#fff", zIndex: "2" }} />

                                        </AreaChart>

                                    </ResponsiveContainer></Fade>

                                </div> : <></>}

                            </div>

                        </div>
                        <div className='grid6'>

                            <div className='in' >

                                <p>Transaction value</p>

                                {(isloaded3 && !loadingTransVal) ? <div style={{ paddingLeft: "15px" }}><div className='chart' style={{ width: "100%", fontWeight: "normal", marginLeft: "0px", padding: "30px 0px 0px 0px", fontSize: "10px" }}>

                                <Fade duration={2000}><ResponsiveContainer width="100%" height={180}>

                                        <AreaChart data={chartTransVal}>

                                            <YAxis tick={{ stroke: 'white', strokeWidth: 1 }} allowDecimals={false} style={{ color: "white" }} tickSize={0} tickLine={false} axisLine={false} padding={{ bottom: 0 }} />
                                        
                                            <Area type="monotone" dataKey='value' stroke="#ADADCC" fill="#ADADCC" />
                                    
                                            <XAxis interval={Math.floor(chartTransVal/9)} angle={0} tick={{ stroke: 'rgb(125, 123, 123)', strokeWidth: 0.3 }} dx={10} dy={8} dataKey="date" tickLine={false} padding={{ left: 0, right: 20 }} tickSize={10} allowDataOverflow={true} minTickGap={30} style={{ backgroundColor: "#fff", zIndex: "2" }} />
                                        </AreaChart>

                                    </ResponsiveContainer></Fade>

                                </div></div> : <></>}

                                {(isloaded3 && !loadingTransVal) ? <div style={{ paddingLeft: "15px" }}><div className='chart' style={{ width: "100%", fontWeight: "normal", marginLeft: "0px", marginTop:"-210px", padding: "30px 0px 0px 0px", fontSize: "10px" }}>

                                <Fade duration={2000}><ResponsiveContainer width="100%" height={180}>

                                        <AreaChart data={chartTransVal}>

                                            <YAxis type='category' dataKey={'y'} allowDuplicatedCategory={false} allowDecimals={false} style={{ color: "white" }} tickSize={22} interval={Math.floor(chartTransVal/5)} tickLine={false} axisLine={false} padding={{ bottom: 0 }} />
                                            
                                            <Area type="monotone" allowDuplicatedCategory={false} dataKey='value' stroke="transparent" fill="transparent" />
                                    
                                            <XAxis interval={Math.floor(chartTransVal/9)} angle={0} tick={{ stroke: 'rgb(125, 123, 123)', strokeWidth: 0.3 }} dx={10} dy={8} dataKey="date" tickLine={false} padding={{ left: 0, right: 20 }} tickSize={10} allowDataOverflow={true} minTickGap={30} style={{ backgroundColor: "#fff", zIndex: "2" }} />
                                        </AreaChart>

                                    </ResponsiveContainer></Fade>

                                </div></div> : <></>}

                            </div>

                        </div>
                    </div>

                </div>

            </Layout>
            <Modal
                open={signOpen}
                onClose={closesign}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={Modalstyle}>

                    <center>

                        <section className="datepicker">

                            <div className="form-input">
                                <label>Starting Date</label>
                                <input type="date" value={fromDate} onChange={(e) => handleFromDate(e.target.value)} />
                            </div>

                            <div className="form-input">
                                <label>Ending Date</label>
                                <input type="date" value={toDate} onChange={(e) => handleToDate(e.target.value)} />
                            </div>

                            <div style={{ width: "100%" }}>
                                <button onClick={() => {ValidateDate() }} className='btn_'>Apply</button>
                            </div>

                        </section>
                    </center>


                </Box>
            </Modal>

        </div>

    );

}